import styled from '@emotion/styled';
export const Badge = styled.div `
  border-radius: 26px;

  display: inline-grid;
  grid-auto-flow: column;
  grid-gap: 6px;

  justify-content: center;
  align-items: center;
  min-width: 48px;
  height: 22px;
  color: white;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  padding: 0 8px;
  white-space: nowrap;
`;
